import React from 'react'

// Components
import FormContact from 'components/flex/Form/FormContact'
import FormSignin from './FormSignin'

export interface FormProps {
  // eslint-disable-next-line
  fields: GatsbyTypes.WpPage_Flexcontent_Flex_Form
  location?: any
}

interface PostProps {
  [key: string]: any
}

const Shell: React.FC<FormProps> = ({ fields, location = {} }) => {
  const types: PostProps = {
    contact: FormContact,
    signin: FormSignin,
  }

  if (!fields.styletype || !types[fields.styletype]) {
    return null
  }

  const Component = types[fields.styletype]

  return (
    <Component
      key={`${location ? location.pathname : 'flex'}`}
      fields={fields}
      location={location}
    />
  )
}

export default Shell
